import { autotrackParams } from "../tracking/tracking";

export const linkTracking = tracking => (
  autotrackParams(Object.assign({ category: "Menu" }, tracking))
);
